// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CVJr","col":"styles_col__3jm2P","actions":"styles_actions__1glNT","conflict":"styles_conflict__AKH2a"};